import { useMatch } from 'react-router-dom';
import clsx from 'clsx';
import SearchBarTrigger from './SearchBarTrigger';
import LocationListContainer from './LocationListContainer';
import HamburgerMenu from './HamburgerMenu';
import ArrowLeft from '../assets/images/arrows/arrow-left.webp';

interface Props {
  navigateToHomepage: Function;
}

const HeaderMobile: React.FC<Props> = ({ navigateToHomepage }) => {
  const isHomePage = useMatch('/');
  const isPonudePage = useMatch('/ponude');

  return (
    <header className={clsx('yettel-header-mobile bg-light-blue', !isHomePage ? 'short-header' : 'has-skirt')}>
      {!isPonudePage ? (
        <div className="full-width d-flex justify-content-between align-items-center">
          <div className="cursor-pointer" onClick={() => navigateToHomepage()}>
            <h1 className="color-primary-color font-yettel-bold fz-25">Y. Shopping</h1>
          </div>
          <div className="d-flex ms-2">
            <SearchBarTrigger />
            <HamburgerMenu />
          </div>
        </div>
      ) : (
        <div className="full-width d-flex justify-content-between align-items-center ps-2 pe-2">
          <div className="cursor-pointer" onClick={() => navigateToHomepage()}>
            <div className="d-flex">
              <img src={ArrowLeft} width={32} height={32} alt="back" />
            </div>
          </div>
          <div className="d-flex ms-2">
            <SearchBarTrigger />
            <HamburgerMenu />
          </div>
        </div>
      )}

      {isHomePage && <LocationListContainer />}
    </header>
  );
};

export default HeaderMobile;
